<template>
    <div class="todo-block" >
        <task-alarm-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </task-alarm-msg>
        <task-alarm-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </task-alarm-msg>
        <div class="todo-head" @click="toogleOpen">
            <span class="title" :style="{color: todoColor}">
                <div :style="{background: todoColor}">
                    <img :src="todoStateImg" alt="">
                </div>
                {{todoTitle}}
            </span>
            <span class="toggleOpen">
                <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
            </span>  
        </div>
        <div v-show="isOpen" class="todo-body">
            <div class="to-be-signed-contract" v-if="todoState == 1">
                <modal class="eval-history" :display="modalState.evalHistory" @modalStatus="closeModal('evalHistory')" >
                    <eval-history></eval-history>
                    <div class="btn-group">
                        <!-- <div class="prev">
                            <img src="@/assets/img/icon/arrow_left_gray.svg" alt="">
                            上一個租客評價
                        </div> -->
                        <button class="default-button confirm" @click="modalState.alarmToPhone = true">簽約</button>
                        <button class="border-button reject" @click="closeModal('evalHistory'), modalState.deleteBeSigned = true">拒絕</button>
                        <!-- <div class="next">
                            下一個租客評價
                            <img src="@/assets/img/icon/arrow_right_gray.svg" alt="">
                        </div> -->
                    </div>
                </modal>
                <modal class="alarm-to-phone" :display="modalState.alarmToPhone" @modalStatus="closeModal('alarmToPhone')" >
                    <h1>簽約</h1>
                    <span>開啟飛豬管家APP，點選預定進行合約簽署</span>
                    <!-- <img src="@/assets/img/qrcode.png" alt=""> -->
                    <vue-qrious :value="hostUrl"  :size="160" level="L"/>
                </modal>
                <modal class="alarm" :display="modalState.deleteBeSigned" @modalStatus="modalState.deleteBeSigned = false" >
                    <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
                    <h1>拒絕房客預訂</h1>
                    <div class="content">
                        確定拒絕房客預訂嗎?拒絕後將無法回復
                    </div>
                    <div class="btn-group">
                        <button class="default-button" @click="rejectCrontract(), $analytics.logEvent('拒絕房客預訂', { screen_name: '拒絕房客預訂'})">確認</button>
                        <button class="border-button" @click="modalState.deleteBeSigned = false">取消</button>
                    </div>
                </modal>
                <div class="wrap" v-if="contractStatus">
                    <span class="progress">
                        <span class="progress-bar">
                            <span class="progress-landlord" >
                                <img src="@/assets/img/icon/radio_white.svg" alt="">
                                房東簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-tanant" :class="{'active': contractStatus == 'WAITING_FOR_TENANT_TO_SIGN'}">
                                <img v-if="contractStatus == 'WAITING_FOR_TENANT_TO_SIGN'" src="@/assets/img/icon/radio_blue.svg" alt="">
                                <img v-else src="@/assets/img/icon/radio_white.svg" alt="">
                                租客簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-desposit" :class="{'active':  contractStatus == 'BOTH_SIGNED_AND_WAITING_FOR_DEPOSIT'}">
                                <img v-if=" contractStatus == 'BOTH_SIGNED_AND_WAITING_FOR_DEPOSIT'" src="@/assets/img/icon/radio_blue.svg" alt="">
                                <img v-else src="@/assets/img/icon/radio_white.svg" alt="">
                                租客付押金
                            </span>
                        </span>
                    </span>
                    <div class="btn-group">
                        <button class="border-button view-contract" @click="getContract(), $analytics.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</button>
                        <router-link :to="{ name: 'bookingmgt'}">
                            <button class="green-button view-booking">
                                預定管理
                                <img src="@/assets/img/icon/arrow_right_white.svg" alt="">
                            </button>
                        </router-link>

                    </div>
                    
                </div>
                <div class="wrap" v-else>
                    <ul>
                        <li v-for="(tanant,index) in beSignedData" :key="index">
                            <div class="user-detail" @click="clickEvent('evalHistory', index), beSignedIndex = index, beSignedCid = tanant.contractCid">
                                <img class="shot" src="@/assets/img/icon/user_shot_gray.svg" alt="">
                                <div class="evaluation">
                                    <span class="name">
                                        {{tanant.tenantName}}
                                    </span>
                                    <evaluation :rate="tanant.avgRate"></evaluation>
                                </div>
                            </div>
                            <div class="group">
                                <div class="group-btn">
                                    <button class="signed green-button-white-bg" @click="modalState.alarmToPhone = true">簽約</button>
                                    <!-- <button class="reject green-button"  :data-id="tanant.contractCid" @click="rejectCrontract(index)">拒絕</button> -->
                                    <button class="reject green-button"  :data-id="tanant.contractCid" @click="modalState.deleteBeSigned = true, beSignedIndex = index, beSignedCid = tanant.contractCid">拒絕</button>
                                </div>
                                <span class="count-down">
                                    <img src="@/assets/img/icon/timer_white.svg" alt="">
                                    倒數
                                    <count-down :timeStamp="translateDate(tanant.signCountDownTiming)"></count-down>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                
            </div>
            <div class="to-be-checked-by-tanant" v-if="todoState == 9">
                <div class="wrap">
                    <span class="title">
                        狀態：紙本合約
                    </span>
                    <button class="green-button-white-bg">通知租客</button>
                </div>
            </div>
            <div class="arrears-alarm" v-if="todoState == 2">
                <div class="wrap">
                    <div class="detial" v-for="(bill, index) in unpaidBill" :key="index">
                        <span class="title">{{bill.billName}} {{bill.unpaidAmount}} 元未繳<br>欠款：{{bill.arrearsDays}} 天</span>
                        <button class="green-button-white-bg" @click="sendMsg('', '您有一筆租金尚未繳款，請立即開啟確認', bill.billCid), $analytics.logEvent('送出催款', { screen_name: '送出催款'})">催款</button>
                    </div>
                    <!-- <div class="setting">
                        <rent-checkbox v-model="arrearsCheckBox" val="0" checkboxMsg="下次自動催款" tickColor="black" bgColor="#fff" borderColor="#d5dad8" :isPropChecked="true"></rent-checkbox>
                        <span>設定</span>
                    </div> -->
                </div>
            </div>
            <div class="contract-expired" v-if="todoState == 3">
                <div class="wrap">
                    <span class="title">發送訊息給房客</span>
                    <div class="msg-text">
                        {{expiredMsg}}
                    </div>
                    <div class="setting">
                        <!-- <rent-checkbox v-model="contractExpiredCheckBox" val="0" checkboxMsg="下次自動發送" tickColor="black" bgColor="#fff" borderColor="#d5dad8" :isPropChecked="true"></rent-checkbox>
                        <span>設定</span> -->
                        <button class="green-button-white-bg" @click="sendMsg('合約快到期', expiredMsg), $analytics.logEvent('合約快到期推播', { screen_name: '合約快到期推播'})">送出</button>
                    </div>
                </div>
            </div>
            <div class="rent-alarm" v-if="todoState == 4">
                <new-bill :cid="houseInfo.contractCid"></new-bill>
                <div class="wrap">
                    <!-- <div class="bill-name">
                        <label>帳單名稱</label><br>
                        <input type="text" v-model="newBill.billName" placeholder="例如：第二期 5 月份">
                    </div>
                    <div class="rent">
                        <label>租金</label><br>
                        <input type="text" v-model="newBill.rent" placeholder="例如： 6000 ">
                        <span v-show="error.newBill.rent" class="error">{{error.newBill.rent}}</span>
                    </div> -->
                    <div class="group">
                        <button class="green-button-white-bg" @click="setNewBill(), $analytics.logEvent('新增費用', { screen_name: '新增費用'})">新增費用</button>
                        <!-- <button class="green-button" @click="modalState.newBill = true">所有項目</button> -->
                    </div>
                </div>
            </div>
            <div v-if="todoState == 7" class="unevaluation">
                <modal class="set-evaluation" :display="modalState.setEvaluation" @modalStatus="closeModal('setEvaluation')" >
                    <h1>評價房客</h1>
                    <div class="wrap">
                        <div class="tenant">
                            <img src="../../../assets/img/icon/user_shot_black.svg" alt="">
                            {{evalTenant.tenantName}}
                        </div>
                        <div class="contract-info">
                            <div>聯絡方式：{{evalTenant.phoneNumber}}</div>
                            <div>租期：{{getFormatDate(evalTenant.contractBeginTime)}} - {{getFormatDate(evalTenant.contractEndTime)}}</div>
                            <div>押金：兩個月</div>
                        </div>
                        <div class="rate-wrap">
                            <span class="title">真實完整敘述，杜絕不良房客</span>
                            <span class="rate" ref="stars">
                                <img @click="setStars(1)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                                <img @click="setStars(2)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                                <img @click="setStars(3)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                                <img @click="setStars(4)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                                <img @click="setStars(5)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                            </span>
                        </div>
                        <textarea v-model="evaluationParams.comment" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                    <div class="btn-group">
                        <button class="default-button confirm" @click="setEvaluation(), $analytics.logEvent('送出新增租客評價', { screen_name: '送出新增租客評價'})">新增</button>
                        <button class="border-button reject" @click="closeModal('setEvaluation')">取消</button>
                    </div>
                </modal>
                <div class="wrap">
                    <ul>
                        <li v-for="(unEval, index) in unEvaluation" :key="index">
                            <div class="user-detail" >
                                <img class="shot" src="@/assets/img/shot.svg" alt="">
                                <div class="evaluation">
                                    <span class="name">
                                        {{unEval.tenantName}}
                                    </span>
                                    <span class="date">
                                        {{getFormatDate(unEval.contractEndTime)}} 到期租約
                                    </span>
                                </div>
                            </div>
                            <button class="green-button-white-bg" @click="setEvaluationClickEvent(index)">評價</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import Evaluation from '@/components/widge/Evaluation.vue';
import CountDown from '@/components/widge/CountDown.vue';
import Modal from '@/components/widge/Modal.vue';
import EvalHistory from '@/components/landlord/houseStatus/EvalHistory.vue';
import VueQrious from 'vue-qrious'
import TaskAlarmMsg from '@/components/widge/TaskAlarmMsg.vue';
import newBill from '@/components/widge/newBill.vue';

import { 
    apiGetBeSignedContract, 
    apiRejectContract,
    apiInsertBill,
    apiGetUnpaidBill,
    apiGetUnEvaluation,
    apiSetEvaluation,
    apiGetContractHouse,
    apiSendMsg,
    apiGetContract,
    baseDomain,
    baseWebUrl,
    apiHadSent
    } from "@/apis/api.js"; 

export default {
    name: 'TodoBlock',
    data () {
        return {
            isOpen: 1,
            hostUrl: baseWebUrl + '?device=1',
            arrowImg: require('@/assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            arrearsCheckBox: '',
            contractExpiredCheckBox: '',
            // newBill: {
            //     contractCid: this.contractCId,
            //     billName: '',
            //     rent: null,
            //     waterBill: null,
            //     gasBill: null,
            //     tvBill: null,
            //     parkingBill: null,
            //     electricityBill: null,
            //     internetBill: null,
            //     cleaningBill: null,
            //     managementBill: null
            // },
            error: {
                newBill:{
                    billName: '',
                    rent: '',
                    gasBill: '',
                    tvBill: '',
                    waterBill: 0,
                    parkingBill: '',
                    electricityBill: '',
                    internetBill: '',
                    cleaningBill: '',
                    managementBill: ''
                }
            },
            beSignedData: [],
            beSignedIndex: null,
            beSignedCid: null,
            modalState: {
                evalHistory: false,
                alarmToPhone: false,
                newBill: false,
                setEvaluation: false,
                deleteBeSigned: false
            },
            unpaidBill: [],
            unEvaluation: [],
            setEvalSelect: 0,
            contractStatus: null,
            evaluationParams: {
                "tenantCid" : null,
                "contractCid" : null,
                "rate" : 5,
                "comment" : null
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            }
        }
    },
    props: {
        todoState: '',
        houseInfo: ''
        // houseCid: '',
        // contractCId: ''
    },
    watch: {
        isOpen: function () {
            if(this.isOpen){
                this.arrowImg = require('@/assets/img/icon/arrow_down_black.svg'),
                this.arrowRotate = '180'
            }else{
                this.arrowImg = require('@/assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '0'
            }
        },
        // newBill: {
        //     handler: function (val) {
        //         if(val.rent){
        //             if(this.checkIsNum(val.rent)){
        //                 this.error.newBill.rent = ''
        //             }else{
        //                 this.error.newBill.rent = '請填寫數字'
        //             }
        //         }
        //         if(val.gasBill) {
        //             if(this.checkIsNum(val.gasBill)){
        //                 this.error.newBill.gasBill = ''
        //             }else{
        //                 this.error.newBill.gasBill = '請填寫數字'
        //             }
        //         }
        //         if(val.tvBill) {
        //             if(this.checkIsNum(val.tvBill)){
        //                 this.error.newBill.tvBill = ''
        //             }else{
        //                 this.error.newBill.tvBill = '請填寫數字'
        //             }
        //         }
        //         if(val.waterBill) {
        //             if(this.checkIsNum(val.waterBill)){
        //                 this.error.newBill.waterBill = ''
        //             }else{
        //                 this.error.newBill.waterBill = '請填寫數字'
        //             }
        //         }
        //         if(val.parkinBill) {
        //             if(this.checkIsNum(val.parkingBill)){
        //                 this.error.newBill.parkingBill = ''
        //             }else{
        //                 this.error.newBill.parkingBill = '請填寫數字'
        //             }
        //         }
        //         if(val.electricityBill) {
        //             if(this.checkIsNum(val.electricityBill)){
        //                 this.error.newBill.electricityBill = ''
        //             }else{
        //                 this.error.newBill.electricityBill = '請填寫數字'
        //             }
        //         }
        //         if(val.interneBill) {
        //             if(this.checkIsNum(val.internetBill)){
        //                 this.error.newBill.internetBill = ''
        //             }else{
        //                 this.error.newBill.internetBill = '請填寫數字'
        //             }
        //         }
        //         if(val.cleaningBill) {
        //             if(this.checkIsNum(val.cleaningBill)){
        //                 this.error.newBill.cleaningBill = ''
        //             }else{
        //                 this.error.newBill.cleaningBill = '請填寫數字'
        //             }
        //         }
        //         if(val.managementBill) {
        //             if(this.checkIsNum(val.managementBill)){
        //                 this.error.newBill.managementBill = ''
        //             }else{
        //                 this.error.newBill.managementBill = '請填寫數字'
        //             }
        //         }
        //     },
        //     deep: true
        // },
    },
    mounted () {
        this.updateState()
    },
    computed: {
        todoTitle: function () {
            if( this.todoState == 1 ){
                return '房客預定'
            }else if( this.todoState == 9 ){
                return '待租客確認'
            }else if( this.todoState == 2 ){
                return '欠款'
            }else if( this.todoState == 3 ){
                return '快到期'
            }else if( this.todoState == 4 ){
                return '收款提醒'
            }else if( this.todoState == 7 ){
                return '尚未評價的房客'
            }
        },
        todoColor: function () {
            if( this.todoState == 1 ){
                return '#71aae5'
            }else if( this.todoState == 9 ){
                return '#3942b5'
            }else if( this.todoState == 2 ){
                return '#fc7171'
            }else if( this.todoState == 3 ){
                return '#676362'
            }else if( this.todoState == 4 ){
                return '#fcb773'
            }else if( this.todoState == 7 ){
                return '#a8a5a4'
            }
        },
        todoStateImg: function () {
            if( this.todoState == '1' ){
                return require('@/assets/img/icon/landlord_check_white.svg');
            }else if( this.todoState == '9' ){
                return require('@/assets/img/icon/tanant_check_white.svg');
            }else if( this.todoState == '2' ){
                return require('@/assets/img/icon/arrears_white.svg');
            }else if( this.todoState == '3' ){
                return require('@/assets/img/icon/recently_white.svg');
            }else if( this.todoState == '4' ){
                return require('@/assets/img/icon/collect_white.svg');
            }else if( this.todoState == 7 ){
                return require('@/assets/img/icon/collect_white.svg');
            }
        },
        expiredMsg: function () {
            return '親愛的房客您好：您的合約即將在'+this.houseInfo.leaveDay+'天後到期，請問您是否要續租？'
        },
        evalTenant: function () {
            if(this.unEvaluation.length>0){
                return this.unEvaluation[this.setEvalSelect]
            }else{
                return {
                    avatarUrl:"",
                    contractBeginTime:"",
                    contractCid:"",
                    contractEndTime:"",
                    deposit:"",
                    phoneNumber:"",
                    signUpTime:"",
                    tenantCid:"",
                    tenantName:"",
                }
            }
        }
    },
    methods: {
        toogleOpen: function () {
            this.isOpen = !this.isOpen
            let state = {
                state: this.isOpen,
                uid: this._uid
            }
            this.$emit('todoState', state)
        },
        closeModal: function (type) {
            if( type == 'evalHistory' ){
                this.modalState.evalHistory = false
            }else if( type == 'alarmToPhone' ){
                this.modalState.alarmToPhone = false
            }else if( type == 'newBill' ){
                this.modalState.newBill = false
            }else if( type == 'setEvaluation' ){
                this.modalState.setEvaluation = false
            }
        },
        getBeSignedContract: function () {

            let data = {
                'houseCid': this.houseInfo.housesCid
            }

            apiGetBeSignedContract(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.beSignedData = res.data.result
                    if(this.beSignedData.length == 0 ){
                        this.getContractStatus()
                    }
                }
            })
            .catch(err => {
                // reject(err)
            })
        },
        getContractStatus: function () {
            // console.log('getContractStatus')
            let data = this.houseInfo.contractCid
            apiGetContractHouse(data)
            .then( res => {
                // console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.contractStatus = res.data.result.contractStatus
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        toContractDetail: function (cid) {
            window.open('/landlord/leasemanagement/contractdetail?cid='+cid)
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                console.log(res)
                
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")

            // let data = this.houseInfo.contractCid;
            // apiGetContract(data)
            // .then(res => {
            //     if( res.data.status == "SUCCESS" ){
            //         window.open(baseDomain+res.data.result.electronicContract, '合約詳情')
            //     }
            // })
            // .catch(err => {
            //     console.log(err)
            // })
        },
        rejectCrontract: function () {
            let data = this.beSignedCid

            apiRejectContract(data)
            .then(res => {
                // console.log(res)
                this.modalState.deleteBeSigned = false
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '拒絕成功'
                    this.$store.dispatch('setApiStatus', 'update')
                    this.beSignedData.splice(this.beSignedIndex, 1);
                }else{
                    this.alart.error = true
                    this.msg.success = '拒絕失敗'
                }
            })
            .catch(err => {
                // reject(err)
            })

        },
        // addNewBill: function () {
        //     let data = {
        //         contractCid: this.newBill.contractCid,
        //         billName: this.newBill.billName,
        //         rent: this.newBill.rent?this.newBill.rent:0,
        //         waterBill: this.newBill.waterBill?this.newBill.waterBill:0,
        //         gasBill: this.newBill.gasBill?this.newBill.gasBill:0,
        //         tvBill: this.newBill.tvBill?this.newBill.tvBill:0,
        //         parkingBill: this.newBill.parkingBill?this.newBill.parkingBill:0,
        //         electricityBill: this.newBill.electricityBill?this.newBill.electricityBill:0,
        //         internetBill: this.newBill.internetBill?this.newBill.internetBill:0,
        //         cleaningBill: this.newBill.cleaningBill?this.newBill.cleaningBill:0,
        //         managementBill: this.newBill.managementBill?this.newBill.managementBill:0
        //     }
        //     apiInsertBill(data)
        //     .then(res => {
        //         console.log(res)
        //         if( res.data.status == "SUCCESS" ){
        //             this.alart.success = true
        //             this.msg.success = '新增費用成功'
        //             this.closeModal('newBill')
        //         }else{
        //             this.alart.error = true
        //             this.msg.success = '新增費用失敗'
        //         }
        //     })
        //     .catch(err => {
        //         // reject(err)
        //     })
        // },
        clickEvent: function (type, index) {
            if( type = 'evalHistory'){
                this.$analytics.logEvent('租客所有評價', { screen_name: '租客所有評價'})
                if(this.beSignedData[index].avgRate != ''){
                    // console.log(this.beSignedData[index])
                    let data = {
                        tenantCid: this.beSignedData[index].tenantCid,
                        tenantName: this.beSignedData[index].tenantName
                    }
                    this.$store.dispatch('setTanant', this.beSignedData[index].tenantName)
                    this.$store.dispatch('setAvgRate', this.beSignedData[index].avgRate)
                    this.$store.dispatch('setCountdown', this.beSignedData[index].signCountDownTiming)
                    this.$store.dispatch('getHistoryRate', data)
                    .then( () => {
                        this.modalState.evalHistory = true
                    })
                    
                }
            }else if( type = 'newBill' ){
                // console.log('newBill')
            }
        },
        translateDate: function (date) {

            let currentDate = new Date(date)
            currentDate = currentDate.setHours(currentDate.getHours())

            return currentDate
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        getUnpaidBill: function (cid) {
            let data = cid
            apiGetUnpaidBill(data)
            .then(res => {
                // console.log(res)
                if(res.data.status = "SUCCESS"){
                    this.unpaidBill = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getUnEvaluation: function (hid) {
            let data = hid
            apiGetUnEvaluation(data)
            .then(res => {
                console.log(res)
                if(res.data.status = "SUCCESS"){
                    this.unEvaluation = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        setStars: function (rate) {
            // console.log(this.$refs)
            this.evaluationParams.rate = rate
            if(this.$refs.stars.children){
                let stars = this.$refs.stars.children
                for (let i = 1; i < 5; i++) {
                    const star = stars[i];
                    if(i<rate){
                        star.src = require('@/assets/img/component/evaluation/star_golden_large.svg')
                    }else{
                        star.src = require('@/assets/img/component/evaluation/star_gray_large.svg')
                    }
                }
            }
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        setEvaluationClickEvent: function (index) {
            this.modalState.setEvaluation = true
            this.setEvalSelect = index
            this.evaluationParams.tenantCid = this.unEvaluation[this.setEvalSelect].tenantCid
            this.evaluationParams.contractCid = this.unEvaluation[this.setEvalSelect].contractCid
        },
        setEvaluation: function (){
            let data = this.evaluationParams
            apiSetEvaluation(data)
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '評價成功'
                    this.$store.dispatch('getHouse')
                }else{
                    this.alart.fail = true
                    this.msg.error = '評價失敗'
                }
                this.closeModal('setEvaluation')
            })
            .catch(err => {
                console.log(err)
            })
        },
        setNewBill: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'newBill'})
        },
        updateState: function () {
            // console.log(this.todoState)
            this.contractStatus = null
            if( this.todoState == 1 ){
                this.getBeSignedContract()
            }
            if( this.todoState == 9 ){

            }
            if( this.todoState == 2 ){
                this.getUnpaidBill(this.houseInfo.contractCid)
            }
            if( this.todoState == 3 ){

            }
            if( this.todoState == 4 ){

            }
            if( this.todoState == 7 ){
                this.getUnEvaluation(this.houseInfo.housesCid)
            }
        },
        sendMsg: function (title, msg, billCid) {
            let data = {
                "account": this.houseInfo.tenantPhone,
                "title": title,
                "message": msg
            }

            apiSendMsg(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '訊息送出成功'
                    this.setHadSent(billCid)
                    this.closeModal()
                }else{
                    this.alart.error = true
                    this.msg.success = '訊息送出失敗'
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setHadSent: function (billCid) {
            let data = {
                "billCid" : billCid,
                "hadSent" : true
            }

            apiHadSent(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
    },
    components: {
        RentCheckbox,
        Evaluation,
        CountDown,
        Modal,
        EvalHistory,
        VueQrious,
        TaskAlarmMsg,
        newBill
    }
}
</script>
<style lang="scss" scoped>
    .todo-block{
        margin-bottom: 24px;
        .todo-head{
            position: relative;
            width: 384px;
            height: 22px;
            padding: 16px 20px;
            background: #fff;
            border-radius: 10px;
            cursor: pointer;
            .title{
                display: flex;
                align-items: center;
                color: #fc7171;
                div{
                    width: 24px;
                    height: 22px;
                    margin-right: 8px;
                    border-radius: 7.5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .toggleOpen{
                position: absolute;
                right: 16px;
                top: 50%;
                transform: translateY(-50%);
                img{
                    width: 24px;
                    height: 24px;
                }
                
            }
        }
        .todo-body{
            position: relative;
            padding: 28px 20px 16px 20px;
            .to-be-signed-contract{
                position: relative;
                ul{
                    li{
                        position: relative;
                        display: flex;
                        align-items: center;
                        margin-bottom: 30px;
                        height: 65px;
                        .user-detail{
                            display: flex;
                            align-items: center;
                            .shot{
                                width: 40px;
                                height: 40px;
                                border-radius: 30px;
                                margin-right: 12px;
                            }
                            .evaluation{
                                display: flex;
                                flex-direction: column;
                                .name{
                                    color: #fff;
                                    margin-bottom: 4px;
                                }
                            }
                            
                        }
                        .group{
                            position: absolute;
                            right: 0px;
                            .group-btn{
                                margin-bottom: 7px;
                                .signed{
                                    margin-right: 8px;
                                }

                            }
                            .count-down{
                                display: flex;
                                color: #fff;
                                align-items: center;
                                justify-content: flex-end;
                                font-weight: 300;
                            }
                        }
                    }
                }
                .progress{
                    display: block;
                    margin-bottom: 27px;
                    .progress-bar{
                        display: flex;
                        align-items: center;
                        .progress-landlord,
                        .progress-tanant,
                        .progress-desposit{
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            color: #fff;
                            img{
                                margin-right: 8px;
                            }
                        }
                        // .progress-landlord.active,
                        // .progress-tanant.active,
                        .progress-desposit.active{
                            opacity: 1;
                        }
                        .progress-landlord,
                        .progress-tanant{
                            width: 72px;
                        }
                        .progress-desposit{
                            opacity: 0.6;
                            width: 85px;
                        }
                        .progress-hr{
                            width: 60px;
                            height: 1px;
                            background: #fff;
                            margin: 0 8px;
                        }
                    }
                }
                >.btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .view-contract{
                        width: 104px;
                        padding: 7px 0;
                        margin-right: 12px;
                    }
                    .view-booking{
                        width: 120px;
                        padding: 4px 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;
                    }
                }
                .alarm{
                    .modal-content{
                        padding: 0 !important;
                        .alarm-img{
                            margin-top: 40px;
                        }
                        h1{
                            font-size: 24px;
                            margin-top: 12px;
                            margin-bottom: 16px;
                        }
                        .content{
                            padding: 0 40px;
                            width: 368px;
                            line-height: 1.57;
                            color: #a8a5a4;
                            text-align: center;
                            margin-bottom: 50px;
                        }
                        .btn-group{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            height: 84px;
                            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                            border-radius:  0 0 20px 20px;
                            margin: 0 auto;
                            button{
                                width: 184px;
                                height: 44px;
                            }
                            button:first-child{
                                margin-right: 14px;
                            }
                        }
                    }
                }
            }
            .to-be-checked-by-tanant{
                position: relative;
                .wrap{
                    height: 36px;
                    display: flex;
                    align-items: center;
                    .title{
                        color: #fff;
                    }
                    button{
                        position: absolute;
                        right: 0;
                    }
                }
            }
            .arrears-alarm{
                position: relative;
                .wrap{
                    .detial{
                        display: flex;
                        margin-bottom: 16px;
                        .title{
                            color: #fff;
                            line-height: 1.71;
                        }
                        button{
                            position: absolute;
                            right: 0;
                        }
                    }
                    .setting{
                        display: flex;
                        align-items: center;
                        color: #fff;
                        span{
                            cursor: pointer;
                            margin-left: 4px;
                            text-decoration: underline;
                        }
                    }
                }
            }
            .contract-expired{
                position: relative;
                .title{
                    display: block;
                    color: #fff;
                    margin-bottom: 12px;
                }
                .wrap{
                    textarea{
                        width: 100%;
                        height: 64px;
                        margin-bottom: 12px;
                    }
                    .msg-text{
                        width: 352px;
                        height: 40px;
                        border-radius: 4px;
                        border: solid 1px #d5dad8;
                        background-color: #fff;
                        padding: 12px 16px;
                        margin-bottom: 12px;
                        line-height: 1.5;
                    }
                    .setting{
                        position: relative;
                        height: 36px;
                        display: flex;
                        align-items: center;
                        color: #fff;
                        span{
                            cursor: pointer;
                            margin-left: 4px;
                            text-decoration: underline;
                        }
                        button{
                            position: absolute;
                            right: 0;
                        }
                    }
                }
            }
            .rent-alarm{
                .wrap{
                    label{
                        color: #fff;
                    }
                    input{
                        width: 352px;
                        margin-top: 12px;
                        margin-bottom: 30px;
                    }
                    .group{
                        position: relative;
                        text-align: center;
                        button:first-child{
                            margin-right: 8px;
                        }
                    }
                }
            }
            .unevaluation{
                position: relative;
                ul{
                    li{
                        position: relative;
                        display: flex;
                        align-items: center;
                        margin-bottom: 30px;
                        height: 65px;
                        .user-detail{
                            display: flex;
                            align-items: center;
                            .shot{
                                width: 40px;
                                height: 40px;
                                border-radius: 30px;
                                margin-right: 12px;
                            }
                            .evaluation{
                                display: flex;
                                flex-direction: column;
                                .name{
                                    color: #fff;
                                    margin-bottom: 4px;
                                }
                                .date{
                                    font-size: 12px;
                                    font-weight: 300;
                                    color: #fff;
                                }
                            }
                            
                        }
                        button{
                            position: absolute;
                            right: 0;
                        }
                    }
                }
            }
        }
        #modal.eval-history{
            .modal-content{
                width: 992px;
                padding: 0;
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    .prev,
                    .next{
                        position: absolute;
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #a8a5a4;
                        cursor: pointer;
                    }
                    .prev{
                        left: 30px;
                    }
                    .next{
                        right: 30px;
                    }
                    button{
                        width: 200px;
                        height: 44px;
                    }
                    button.confirm{
                        margin-right: 16px;
                    }
                }
            }
        }
        #modal.set-evaluation{
            .modal-content{
                width: 696px;
                height: 667px;
                padding: 0;
                .detail{
                    >h1{
                        margin-top: 32px;
                        margin-bottom: 50px;
                    }
                    .wrap{
                        width: 632px;
                        margin-bottom: 184px;
                        padding: 0 32px;
                        .tenant{
                            display: flex;
                            align-items: center;
                            font-weight: 500;
                            margin-bottom: 16px;
                            img{
                                margin-right: 8px;
                            }
                        }
                        .contract-info{
                            margin-bottom: 40px;
                            >div{
                                margin-bottom: 8px;
                            }
                        }
                        .rate-wrap{
                            position: relative;
                            margin-bottom: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .title{
                                font-weight: 500;
                            }
                            .rate{
                                >img{
                                    cursor: pointer;
                                }
                            }
                        }
                        textarea{
                            width: 632px;
                            height: 85px;
                            resize: none;
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 200px;
                            height: 44px;
                        }
                        button.confirm{
                            margin-right: 16px;
                        }
                    }
                }
                
            }
        }
        // modal
        #modal.alarm-to-phone{
            text-align: center;
            .modal-content{
                padding: 30px;
                h1{
                    margin-bottom: 28px;
                }
                span{
                    display: block;
                    width: 278px;
                    margin: 0 55px;
                    font-weight: 300;
                    line-height: 1.57;
                    margin-bottom: 30px;
                }
                img{
                    margin-bottom: 10px;
                }
            }
        }
        #modal.new-bill{
            .modal-content{
                width: 448px;
                padding: 0;
                .detail{
                    >h1{
                        margin-top: 32px;
                        margin-bottom: 24px;
                    }
                    .new-bill-wrap{
                        padding: 0 32px 0 32px;
                        .input-wrap{
                            margin-bottom: 30px;
                            >span{
                                display: block;
                                margin-bottom: 12px;
                            }
                            >.input-error-group{
                                >input{
                                    width: 352px;
                                }
                            }
                        }
                        .new-bill-group{
                            display: flex;
                            .left{
                                margin-right: 28px;
                                .input-wrap{
                                    >.input-error-group{
                                        >input{
                                            width: 146px;
                                        }
                                    }
                                }
                            }
                            .right{
                                .input-wrap{
                                    >.input-error-group{
                                        >input{
                                            width: 146px;
                                        }
                                    }
                                }
                            }
                        }
                        
                    }
                }
                
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button.confirm{
                        margin-right: 16px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/TodoBlock.vue